import React from 'react';
import SimulatorsViewerArrangement from '../FullPagesComponents/SimulatorsViewerArrangement';
import EmptyFullPageSimulator from '../FullPagesComponents/EmptyFullPageSimulator';
import Launch_not_supportedFP from '../FullPagesComponents/Interaction/Launch_not_supportedFP';
import Launch_error_messagesFP from '../FullPagesComponents/Interaction/Launch_error_messagesFP';
import {
  general_error_icon,
  general_error_message,
  no_connection,
  no_connection_icon, permission_to_photos, permission_to_photos_str,
  transaction_failed,
  transaction_failed_icon,
} from '../../../utils/DictionaryManagementUtils';
import { xlateText } from '../../../utils/Utils';

//= ========================================================================
const Launch_error_messagesDF = ({
  globJSON,
  language,
  simPlatform,
  slideshowRefs = null,
}) => {
  const { error_messages } = globJSON.configurations.launch;
  return (
    <SimulatorsViewerArrangement>
      <Launch_error_messagesFP
        globJSON={globJSON}
        simPlatform={simPlatform}
        imageKey={general_error_icon}
        imageSource={error_messages.general_error_icon}
        txtTitleStr={xlateText(error_messages.error_message_general_error)}
        TopTitle={general_error_message}
        BtnInputText={error_messages.try_again}
        slideshowRefs={slideshowRefs}
      />
      <Launch_error_messagesFP
        globJSON={globJSON}
        simPlatform={simPlatform}
        imageKey={no_connection_icon}
        imageSource={error_messages.no_connection_icon}
        txtTitleStr={xlateText(error_messages.error_message_no_connection)}
        TopTitle={no_connection}
        BtnInputText={error_messages.reload}
        slideshowRefs={slideshowRefs}
      />
      <Launch_error_messagesFP
        globJSON={globJSON}
        simPlatform={simPlatform}
        imageKey={transaction_failed_icon}
        imageSource={error_messages.transaction_failed_icon}
        txtTitleStr={xlateText(error_messages.error_message_transaction_failed)}
        TopTitle={transaction_failed}
        BtnInputText={error_messages.try_again}
        slideshowRefs={slideshowRefs}
      />
      <Launch_error_messagesFP
        globJSON={globJSON}
        simPlatform={simPlatform}
        imageKey={permission_to_photos}
        imageSource={error_messages.permission_to_photos_icon}
        txtTitleStr={xlateText(error_messages.error_message_permission_to_photos)}
        TopTitle={permission_to_photos_str}
        BtnInputText={error_messages.take_me_to_settings}
        slideshowRefs={slideshowRefs}
      />
      <EmptyFullPageSimulator />
      <Launch_not_supportedFP
        globJSON={globJSON}
        language={language}
        simPlatform={simPlatform}
        slideshowRefs={slideshowRefs}
      />
    </SimulatorsViewerArrangement>
  );
};

export default Launch_error_messagesDF;
